import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { NavbarComponent } from './components/navbar/navbar.component';
import { MatSortModule } from '@angular/material/sort';
import { InfringementDetailsComponent } from './components/infringement-details/infringement-details.component';
import { InfringementDetailsContractBreachComponent } from './components/infringement-details/infringement-details-contract-breach/infringement-details-contract-breach.component';
import { InfringementDetailsIpInfringementComponent } from './components/infringement-details/infringement-details-ip-infringement/infringement-details-ip-infringement.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ItSecurityCheckComponent } from './components/it-security-check/it-security-check.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { AddInfringementComponent } from './components/add-infringement/add-infringement.component';
import { MatCardModule } from '@angular/material/card';
import { MatStepperModule } from '@angular/material/stepper';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatListModule } from '@angular/material/list';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { AddCompanyComponent } from './components/add-company/add-company.component';
import { MatSelectModule} from '@angular/material/select';
import { MatRadioModule} from '@angular/material/radio';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { OktaAuthModule, OktaConfig } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from '../environments/environment';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { Injector } from '@angular/core';


const oktaAuth = new OktaAuth({
  issuer: environment.okta.issuer,
  clientId: environment.okta.clientId,
  redirectUri: environment.okta.redirectUri,
  scopes: environment.okta.scopes,
  postLogoutRedirectUri: environment.okta.postLogoutRedirectUri,
});

export function onAuthRequired(oktaAuth: OktaAuth, injector: Injector) {
  // Direkt zum Okta-Login, ohne eigenen Button
  return oktaAuth.signInWithRedirect();
}

const oktaConfig: OktaConfig = { oktaAuth, onAuthRequired };

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    ItSecurityCheckComponent,
    InfringementDetailsComponent,
    AddInfringementComponent,
    AddCompanyComponent,
  ],
  imports: [
    DashboardComponent,
    BrowserModule,
    AppRoutingModule,
    MatToolbarModule,
    MatButtonModule,
    MatFormFieldModule,
    FormsModule,
    MatSortModule,
    MatInputModule,
    CommonModule,
    MatProgressSpinnerModule,
    InfringementDetailsContractBreachComponent,
    InfringementDetailsIpInfringementComponent,
    HttpClientModule,
    MatIconModule,
    ReactiveFormsModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatStepperModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatCheckboxModule,
    MatListModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatRadioModule,
    MatAutocompleteModule,
    OktaAuthModule.forRoot(oktaConfig),
    LoginComponent
  ],
  providers: [
    provideAnimationsAsync(),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
